module.exports = __webpack_public_path__ + "static/ultraschall@2x.d77460ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/home/ultraschall@2x.jpg
// module id = 470
// module chunks = 35783957827783